/*
 * FAQ w treści artykułu bloga — rozwijanie (akordeon) dla wstawki HTML.
 *
 * Budowa oparta na zwykłych <div> (NIE <details>/<summary>), bo edytor
 * artykułów w panelu Shopify przy zapisie usuwa <details>/<summary>.
 *
 * Oczekiwany markup w treści wpisu:
 *   <div class="blog-faq">
 *     <div class="blog-faq__heading">FAQ</div>
 *     <div class="blog-faq__item">
 *       <div class="blog-faq__q">Pytanie?</div>
 *       <div class="blog-faq__a"><p>Odpowiedź.</p></div>
 *     </div>
 *     ...
 *   </div>
 *
 * Bez JS: wszystkie odpowiedzi są widoczne (dobre dla czytelności i crawlerów).
 * Z JS: wiersze zwijają się, klik na pytanie rozwija odpowiedź.
 */
(function () {
  'use strict';

  function enhance(faq) {
    faq.classList.add('blog-faq--js');
    var items = faq.querySelectorAll('.blog-faq__item');
    for (var i = 0; i < items.length; i++) {
      wire(items[i]);
    }
  }

  function wire(item) {
    var q = item.querySelector('.blog-faq__q');
    if (!q) return;
    q.setAttribute('role', 'button');
    q.setAttribute('tabindex', '0');
    q.setAttribute('aria-expanded', 'false');

    function toggle() {
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    q.addEventListener('click', toggle);
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle();
      }
    });
  }

  function init() {
    var container =
      document.querySelector('.article-template__content') || document;
    var faqs = container.querySelectorAll('.blog-faq');
    for (var i = 0; i < faqs.length; i++) {
      enhance(faqs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
